import { SupplierData } from "../json/supplier_data";
import { StockTransferData } from "../json/stocktransferdata";
import { userlisadata } from "../json/users";
import { rolesandpermission } from "../json/rolesandpermissiondata";

const safeJsonParse = (item, defaultValue) => {
  try {
    return JSON.parse(item) || defaultValue;
  } catch (e) {
    return defaultValue;
  }
};
const initialState = {
  store_list: [],
  store_edit: null,
  toggle_header: false,
  supplierdata: SupplierData,
  stocktransferdata: StockTransferData,
  userlist_data: userlisadata,
  rolesandpermission_data: rolesandpermission,
  layoutstyledata: localStorage.getItem("layoutStyling"),
  selected_period: localStorage.getItem("selected_period") || null,
  compare_period: localStorage.getItem("compare_period") || null,

  accessToken: localStorage.getItem('accessToken') || null,
  targets: { // target achivement data
    dailyTarget: {
      achieved: '0',
      targetFormatted: '0',
      target: '0',
      remainingFormatted: '0',
      remaining: '0',
      achievedFormatted: '0'
    }, // dailyTarget
    weeklyTarget: {
      achieved: '0',
      targetFormatted: '0',
      target: '0',
      remainingFormatted: '0',
      remaining: '0',
      achievedFormatted: '0'

    }, // weekly Target
    monthlyTarget: {
      achieved: '0',
      targetFormatted: '0',
      target: '0',
      remainingFormatted: '0',
      remaining: '0',
      achievedFormatted: '0'
    }, // monthlyTarget
  },
  layoutGlobal:[],
  token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiJ0ekpFTlNxcDJXeXh4YlNGbSIsImFjY2Vzc1Rva2VuRXhwIjp7ImRhdGUiOiIyMDI0LTA3LTI2IiwidGltZSI6IjA0OjAxOjIwIiwidGltZVN0YW1wIjoxNzIxOTM0MDgwOTI1LCJnbXQiOiIrMDkwMCJ9LCJyZWZyZXNoVG9rZW5FeHAiOnsiZGF0ZSI6IjIwMjQtMDctMjYiLCJ0aW1lIjoiMDQ6MDE6MjAiLCJ0aW1lU3RhbXAiOjE3MjE5MzQwODA5MjYsImdtdCI6IiswOTAwIn0sImlhdCI6MTcxOTM0MjA4MCwiZXhwIjoxNzE5MzQyMTQwfQ.IkM5aQpLfyRUdOgGCQRKA7Qzk9-ro7sOqcgK2sSnd4c",
  addModelDetail:{},
  permissions: safeJsonParse(localStorage.getItem("permissions"), null),
  roleTitle: localStorage.getItem("roleTitle") || "",
  roleTitleAdmin: 'TenantAdmin',
  storeEditW: null,
  //
  translations:{},
  translation:{},
  subMenu:{},
};

export default initialState;
